import PropTypes from "prop-types"
import { chain } from "lodash"
import { Paper } from "@mui/material"
import Table from "components/material/table"
import columns from "./columns"
import ExcelDownload from "components/excel-download"

export default function UntaggedSecurities({ portfolioAlias, securities, rowsPerPage, uploadDate }) {
  const fileName = `${portfolioAlias} - Untagged securities - ${uploadDate}`
  const data = [
    ["Identifier", "Lot Id", "Tag Category", "From", "To", "Max GMV %", "Counts"],
    ...chain(securities)
      .sortBy(["identifier", "tagCategory"])
      .map(({ identifier, tagCategory, lotId, from, to, maxGMV, counts }) => ([identifier, lotId, tagCategory, from, to, maxGMV, counts]))
      .values(),
  ]

  return <Paper square elevation={1} className="tag-coverage-report">
    <Table
      title="Tag category coverage breakdown"
      idField="id"
      columns={columns}
      data={securities}
      addForm={false}
      pagination
      rowsPerPage={rowsPerPage}
      rowsPerPageOptions={[]}
      actions={[<ExcelDownload key="excel-download" data={data} fileName={fileName} />]}
    />
  </Paper>
}

UntaggedSecurities.propTypes = {
  portfolioAlias: PropTypes.string.isRequired,
  securities: PropTypes.array.isRequired,
  rowsPerPage: PropTypes.number,
  uploadDate: PropTypes.string.isRequired,
}
